import dayjs, { Dayjs } from 'dayjs';
import { components } from 'type/ReportServiceSchema';
import { DepartmentModel, mapDepartmentDtoToModel } from 'api/dto/new/Perspectives/Department.dto';
import {
  DemographicClassificationModel,
  mapDemographicClassificationDtoToModel,
} from 'api/dto/new/Perspectives/DemographicClassification.dto';
import {
  SentimentTopicModel,
  mapSentimentTopicDtoToModel,
} from 'api/dto/new/Perspectives/SentimentTopic.dto';
import {
  PerspectiveStatusModel,
  mapPerspectiveStatusDtoToModel,
} from 'api/dto/new/Perspectives/PerspectiveStatus.dto';
import { AvatarModel, mapCustomAvatarDtoToModel } from 'api/dto/new/Perspectives/Avatar.dto';
import { FailureCodeEnum } from 'component/Perspectives/FailedPerspectiveSection/FailureMessage';

export type PerspectiveDto = components['schemas']['PerspectiveDTO'] & {
  // TODO: below extends are not present in the dto, remove them in actual implementation
  disabled?: boolean;
  videoUrl?: string;
  transcript?: string;
  keyPoints?: { title: string; description: string }[];
};

export type PerspectiveModel = Readonly<{
  id: string;
  title: string;
  createdBy: string;
  perspectiveKey: string;
  perspectiveAvatarId: string;
  departments: DepartmentModel[];
  demographics: DemographicClassificationModel[];
  topic: SentimentTopicModel;
  requestedAt: Dayjs;
  status: PerspectiveStatusModel;
  customAvatar?: AvatarModel | null;
  failureCode?: FailureCodeEnum | null;
  // TODO: Remove below fields and use proper source of this data (done for demo purpose)
  disabled?: boolean;
  videoUrl?: string;
  transcript?: string;
  keyPoints?: { title: string; description: string }[];
}>;

export const mapPerspectiveDtoToModel = (dto: PerspectiveDto): PerspectiveModel => ({
  id: dto.id,
  title: dto.title,
  createdBy: dto.createdBy,
  perspectiveKey: dto.perspectiveKey,
  perspectiveAvatarId: dto.perspectiveAvatarId,
  departments: dto.departments.map(mapDepartmentDtoToModel),
  demographics: dto.demographics.map(mapDemographicClassificationDtoToModel),
  topic: mapSentimentTopicDtoToModel(dto.topic),
  requestedAt: dayjs(dto.requestedAt),
  status: mapPerspectiveStatusDtoToModel(dto.status),
  customAvatar: dto.customAvatar ? mapCustomAvatarDtoToModel(dto.customAvatar) : null,
  failureCode: dto.failureCode as FailureCodeEnum | null | undefined,
  // TODO: Remove below fields and use proper source of this data (done for demo purpose)
  disabled: dto.disabled,
  videoUrl: dto.videoUrl,
  transcript: dto.transcript,
  keyPoints: dto.keyPoints,
});
